/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import { useEffect, useState } from "react";
import { Input} from "reactstrap";
import { UniqKey } from "../../../util/Key";
import { contrastingForegroundColor } from "../../../util/Color";
import ModalColorPicker from "./ModalColorPicker";
import LayoutFormButton from "./LayoutFormButton";

const LayoutColorForm = ({config, alpha = false, onContentChange, onEditStart}) => {
  // state
  const initialState = {
    color: config ?? (alpha ? "#00000080" : "#000000"),
    validColor: true,
    showModal: false,
    inputKey: config
  };
  const [state, setState] = useState(initialState);

  useEffect(() => {
    if (state.showModal) {
      return;
    }
    const nextColor = config ?? (alpha ? "#00000080" : "#000000");
    setState((prevState) => {
      if ((prevState.color ?? "").toUpperCase() === nextColor.toUpperCase()) {
        return prevState;
      }
      return {
        ...prevState,
        color: nextColor,
        validColor: true,
        inputKey: UniqKey(),
      };
    });
  }, [config, alpha, state.showModal]);

  // handlers
  const setColor = (color, render = true) => {
    // validate color
    const hexColorRegex = alpha ? /^#[0-9A-Fa-f]{8}$/ : /^#[0-9A-Fa-f]{6}$/;
    const valid = hexColorRegex.test(color);

    // update state
    const renderKey = render ? { inputKey: UniqKey() } : {};
    setState(prevState => ({
      ...prevState,
      ...renderKey,
      color: color,
      validColor: valid
    }));

    // return new color if valid
    if (valid) {
      onContentChange(color.toUpperCase());
    }
  };

  // set state
  const setShowModal = (show) => {
    setState(prevState => ({
      ...prevState,
      showModal: show
    }));
  }

  return (
    <div className="d-flex justify-content-center align-items-center">
      <Input
        key={state.inputKey}
        defaultValue={config}
        onChange={(event) => {
          onEditStart?.();
          setColor(event.target.value, false);
        }}
        invalid={!state.validColor}
        maxLength={alpha ? 9 : 7}
      />
      <LayoutFormButton
        className="ms-2"
        icon="eyedropper"
        onClick={() => {
          onEditStart?.();
          setShowModal(true);
        }}
        style={{
          backgroundColor: state.validColor ? state.color.slice(0, 7) : "",
          color: state.validColor ? contrastingForegroundColor(state.color) : ""
        }}
      />
      <ModalColorPicker
        isOpen={state.showModal}
        toggle={() => setShowModal(false)}
        alpha={alpha}
        color={state.validColor ? state.color : (alpha ? "#000000FF" : "#000000")}
        onChange={setColor}
      />
    </div>
  );
};

export default LayoutColorForm;
